import React, { useState } from "react";
import styled from "./Navbar.module.css";
import { Link } from "react-scroll";
import { HiMenu, HiX } from "react-icons/hi";
import img from "../files/27938162.jpeg";

const links = [
  { to: "intro", label: "About" },
  { to: "skills", label: "Skills" },
  { to: "project", label: "Projects" },
  { to: "contact", label: "Contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styled.main}>
      <div className={styled.inner}>
        <Link
          to="intro"
          smooth={true}
          duration={500}
          className={styled.brand}
          onClick={() => setOpen(false)}
        >
          <img className={styled.img} src={img} alt="Md Miftahul Islam logo" />
          <span className={styled.brandText}>Miftahul Islam</span>
        </Link>

        <nav className={`${styled.links} ${open ? styled.open : ""}`}>
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              hashSpy={true}
              spy={true}
              smooth={true}
              delay={100}
              duration={500}
              offset={-90}
              activeClass={styled.active}
              className={styled.link}
              onClick={() => setOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <button
          className={styled.toggle}
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((prev) => !prev)}
        >
          {open ? <HiX /> : <HiMenu />}
        </button>
      </div>
    </div>
  );
};

export default Navbar;
